
import { useState, useEffect } from 'react';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    'https://public.readdy.ai/ai/img_res/cc099b1fd3cc12298b06e0c156bc40a6.jpg',
    'https://readdy.ai/api/search-image?query=Pokemon%20card%20buying%20service%2C%20cash%20transaction%2C%20professional%20card%20evaluation%2C%20vintage%20cards%20being%20examined%2C%20magnifying%20glass%20and%20price%20guides%2C%20clean%20desk%20setup%20in%20card%20shop&width=400&height=200&seq=2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Mobile%20Pokemon%20card%20buying%20service%2C%20delivery%20truck%20with%20Pokemon%20card%20shop%20branding%2C%20professional%20service%20vehicle%2C%20clean%20and%20trustworthy%20appearance%2C%20Japanese%20style%20service&width=400&height=200&seq=3&orientation=landscape'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-red-600 text-white px-4 py-4">
        <div className="flex items-center justify-center">
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-3">
            <i className="ri-shopping-bag-3-fill text-red-600 text-xl"></i>
          </div>
          <h1 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
            出張高価買取、販売　ぽけ太郎
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 py-6">
        {/* Hero Banner */}
        <section className="mb-8">
          <div className="relative bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-6 text-white text-center shadow-lg overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 opacity-10">
              <img 
                src="https://readdy.ai/api/search-image?query=Cute%20cartoon%20Pokemon%20Pikachu%20character%2C%20friendly%20mascot%20style%2C%20yellow%20electric%20mouse%20Pokemon%2C%20cheerful%20expression%2C%20simple%20clean%20design%2C%20transparent%20background%20style%2C%20anime%20illustration&width=128&height=128&seq=banner1&orientation=squarish"
                alt="Pikachu"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="relative z-10">
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
                ぽけ太郎
              </h2>
              <p className="text-lg font-semibold mb-1">ポケモンカード専門店</p>
              <p className="text-sm opacity-90">出張買取・高価買取・豊富な在庫</p>
            </div>
          </div>
        </section>

        {/* Hero Section */}
        <section className="mb-8">
          <div className="relative h-48 rounded-lg overflow-hidden shadow-lg mb-4">
            <img
              src={slides[currentSlide]}
              alt="Store Service"
              className="w-full h-full object-cover object-top transition-opacity duration-500"
            />
            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentSlide ? 'bg-white' : 'bg-white/50'
                  }`}
                />
              ))}
            </div>
          </div>
          
          <div className="text-center">
            <h2 className="text-lg font-bold text-red-600 mb-2">
              ポケモンカード高価買取・販売専門店！
            </h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              出張買取サービスでご自宅まで伺います！<br/>
              高価買取と豊富な在庫で、ポケモンカードのことなら何でもお任せください！
            </p>
          </div>
        </section>

        {/* Trust Banner */}
        <section className="mb-8">
          <div className="bg-blue-50 border-l-4 border-blue-500 rounded-r-lg p-4">
            <div className="flex items-center">
              <i className="ri-shield-check-fill text-blue-500 text-xl mr-3"></i>
              <div>
                <h4 className="font-bold text-gray-900 text-sm">安心・信頼の実績</h4>
                <p className="text-gray-700 text-xs">
                  熊本県内多数のお客様にご利用いただいております
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Store Info */}
        <section className="bg-gray-50 rounded-lg p-6 mb-8">
          <h3 className="font-bold text-gray-900 mb-4 text-center">店舗情報</h3>
          
          <div className="space-y-4">
            <div className="flex items-start">
              <i className="ri-map-pin-line text-red-600 mr-3 mt-1"></i>
              <div>
                <p className="font-semibold text-gray-900">住所</p>
                <p className="text-gray-700 text-sm">
                  〒861-4115<br/>
                  熊本県熊本市南区御幸笛田8-5-15
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-phone-line text-red-600 mr-3 mt-1"></i>
              <div>
                <p className="font-semibold text-gray-900">電話番号</p>
                <a href="tel:08091054340" className="text-red-600 font-semibold text-sm">
                  080-9105-4340
                </a>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-chat-3-line text-red-600 mr-3 mt-1"></i>
              <div>
                <p className="font-semibold text-gray-900">LINE ID</p>
                <p className="text-red-600 font-semibold text-sm">
                  derikuma
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-time-line text-red-600 mr-3 mt-1"></i>
              <div>
                <p className="font-semibold text-gray-900">営業時間</p>
                <p className="text-gray-700 text-sm">
                  10:00~22:00<br/>
                  定休日: なし
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="mb-8">
          <h3 className="font-bold text-gray-900 mb-4 text-center">サービス</h3>
          
          <div className="grid grid-cols-1 gap-4">
            <div className="bg-blue-50 rounded-lg p-4 text-center">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-car-line text-white text-lg"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">出張買取</h4>
              <p className="text-gray-700 text-xs">
                ご自宅まで無料で出張買取いたします！大量のカードもお任せください！
              </p>
            </div>

            <div className="bg-green-50 rounded-lg p-4 text-center">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-money-dollar-circle-line text-white text-lg"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">高価買取</h4>
              <p className="text-gray-700 text-xs">
                レアカード、プロモカード、旧裏面カードなど高価買取中！
              </p>
            </div>

            <div className="bg-purple-50 rounded-lg p-4 text-center">
              <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shopping-bag-line text-white text-lg"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">カード販売</h4>
              <p className="text-gray-700 text-xs">
                豊富な在庫でお探しのカードが見つかります！シングルカードも充実！
              </p>
            </div>
          </div>
        </section>

        {/* Map */}
        <section className="mb-8">
          <h3 className="font-bold text-gray-900 mb-4 text-center">アクセス</h3>
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="h-48">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.8567890123456!2d130.69876543210987!3d32.74567890123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3540f3c8b1234567%3A0x1234567890abcdef!2z44CSODYxLTQxMTUg54aK5pys55yM54aK5pys5biC5Y2X5Yy65b6h5bmz56yb55Sw77yY4oiS77yV4oiS77yR77yV!5e0!3m2!1sja!2sjp!4v1640995200000!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="店舗所在地"
              />
            </div>
          </div>
        </section>

        {/* Special Offer */}
        <section className="bg-red-600 text-white rounded-lg p-6 text-center mb-8">
          <h3 className="text-lg font-bold mb-3">出張買取キャンペーン実施中！</h3>
          <p className="text-sm mb-4 leading-relaxed">
            今なら出張費無料！<br/>
            まとめて売ると買取価格アップ！お気軽にお電話ください！
          </p>
          <a href="tel:08091054340" className="bg-white text-red-600 font-bold py-2 px-6 rounded-lg text-sm inline-block">
            今すぐ電話
          </a>
        </section>

        {/* Contact */}
        <section className="text-center">
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="font-bold text-gray-900 mb-2">
              出張高価買取、販売　ぽけ太郎
            </h3>
            <p className="text-gray-600 mb-4 text-sm">お気軽にお問い合わせください</p>
            <div className="flex justify-center space-x-4">
              <a href="tel:08091054340" className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg flex items-center text-sm">
                <i className="ri-phone-line mr-2"></i>
                電話する
              </a>
              <button className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg flex items-center text-sm">
                <i className="ri-chat-3-line mr-2"></i>
                LINE
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}